import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { PolGemeindeComponent } from '../../../../shared/widgets/pol-gemeinde/pol-gemeinde.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { OrtschaftSelectionComponent } from '../../../../shared/widgets/ortschaft/ortschaft-selection.component';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { AvgebaeudeService, GebaeudeStandardRequestMeta } from '../../../../core/av-api';
import { Subscription } from 'rxjs';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { GebaeudeFormService } from '../../gebaeude-form.service';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { PolitischeGemeindeSearchmode } from '../../../../shared/widgets/pol-gemeinde/politische-gemeinde-searchmode';

@Component({
  selector: 'cap-gebaeude-suche-standard',
  templateUrl: './gebaeude-suche-standard.component.html',
  styleUrls: ['./gebaeude-suche-standard.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    PolGemeindeComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    OrtschaftSelectionComponent,
    TranslatePipe
  ]
})
export class GebaeudeSucheStandardComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  gebaeudeRequest: GebaeudeStandardRequestMeta;
  @ViewChild(PolGemeindeComponent, { static: false })
  private polGemeindeComponent: PolGemeindeComponent;

  @ViewChild(OrtschaftSelectionComponent, { static: false })
  private ortschaftSelection: OrtschaftSelectionComponent;

  polGemeindeSearchMode = PolitischeGemeindeSearchmode.GEBAEUDE_SEARCH;
  private strassenSubscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private gebaeudeStrasseService: AvgebaeudeService,
    private route: ActivatedRoute,
    private formService: GebaeudeFormService,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit() {
    if (this.stateService.lastRequest && this.stateService.lastSearchMode === SearchMode.searchStandard) {
      this.gebaeudeRequest = this.stateService.lastRequest;
    } else {
      this.gebaeudeRequest = <GebaeudeStandardRequestMeta>{};
    }

    this.strassenSubscription = this.gebaeudeStrasseService.searchGebaeudeStandardTemplate().subscribe((template) => {
      this.gebaeudeRequest = this.copyLastRequest(template);
    });
  }

  onSubmit(): void {
    this.stateService.lastRequest = this.gebaeudeRequest;
    this.stateService.lastSearchMode = SearchMode.searchStandard;
    this.timepointService.resetTimepoint();
    this.formService.submit(this.form, SearchMode.searchStandard, this.gebaeudeRequest, this.router, this.route, true);
  }

  onReset() {
    this.form.reset();
    this.strassenSubscription = this.gebaeudeStrasseService.searchGebaeudeStandardTemplate().subscribe((template) => {
      this.polGemeindeComponent.focus();
      this.gebaeudeRequest = template;
    });
  }

  emptyGemeindeSearch() {
    this.polGemeindeComponent.onClear();
    this.gebaeudeRequest.polGemeindeId = null;
  }

  emptyOrtschaftSearch() {
    this.ortschaftSelection.onClear();
    this.gebaeudeRequest.ortschaftVersionId = null;
  }

  ngOnDestroy(): void {
    this.strassenSubscription?.unsubscribe();
  }
}
